export enum EOIPaymentStatus {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  TransactionFailed = 'TransactionFailed',
  TransactionSucceeded = 'TransactionSucceeded',
}
export default EOIPaymentStatus;
